<div class="container-fluid pt-2" style="height: 400px;">
    <div class="row">
        <div class="col-md-12">
            <div class="col d-flex align-items-center">
                <img class="image-icon-sm" src="content/images/list-types.png">
                <h4 class="mt-1 ms-1">
                    <span jhiTranslate="design-crosses.list.entries">List Entries</span>&nbsp;
                </h4>
            </div>
        </div>
    </div>
    <div class="row mt-2">
        <div class="col-6 d-flex align-items-center justify-content-start">
             <span jhiTranslate="global.total.entries" [translateValues]="{param: totalItems}"></span>
            @if (crossSourceEntries.length > 0) {
                <jhi-selection-count [showSelectAll]="true"
                                     [isSelectAll]="isSelectAll"
                                     [totalItemsSize]="totalItems"
                                     [selectedItemsSize]="selectedItems.size"
                                     (deselectAction)="clearSelectedItems()"
                                     (selectAllAction)="selectAll($event)"></jhi-selection-count>
            }
        </div>
        <div class="col-6 d-flex align-items-center justify-content-end">
            <div ngbDropdown class="d-inline-block ps-2" placement="bottom-right">
                <button  class="btn btn-info btn-sm" id="columnsDropdown" ngbDropdownToggle>
                    <span translate="study-editor.actions"></span>
                </button>
                <div ngbDropdownMenu aria-labelledby="columnsDropdown">
                    <button ngbDropdownItem type="submit"
                            (click)="addToParentsList(false)">
                        <span jhiTranslate="design-crosses.actions.add.to.male"></span>
                    </button>
                    <button ngbDropdownItem type="submit"
                            (click)="addToParentsList(true)">
                        <span jhiTranslate="design-crosses.actions.add.to.female"></span>
                    </button>
                    <button ngbDropdownItem type="submit"
                            (click)="selectEvenEntries()">
                        <span jhiTranslate="design-crosses.actions.select.even"></span>
                    </button>
                    <button ngbDropdownItem type="submit"
                            (click)="selectOddEntries()">
                        <span jhiTranslate="design-crosses.actions.select.odd"></span>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="row mt-2">
        <div class="col-md-12">
            <div class="table-responsive custom-scroll-style" style="height: 260px; overflow: auto">
                <table class="table table-striped table-bordered table-curved">
                    <thead class="sticky-header">
                    <tr jhiSort [(predicate)]="predicate" [(ascending)]="reverse" [callback]="sort.bind(this)">
                        <th><input type="checkbox" class="form-check-input" [ngbTooltip]="'global.select.current.page' | translate" [checked]="isPageSelected()" (click)="onSelectPage()" [title]=" 'global.select.all.items' | translate "></th>
                        <th [jhiSortBy]="ColumnHeaders.ENTRY_NO"><span>#</span> <span class="fa fa-sort"></span></th>
                        <th [jhiSortBy]="ColumnHeaders.DESIGNATION"><span jhiTranslate="design-crosses.source.list.desig">DESIGNATION</span> <span class="fa fa-sort"></span></th>
                        <th [jhiSortBy]="ColumnHeaders.CROSS"><span jhiTranslate="design-crosses.source.list.cross">CROSS</span> <span class="fa fa-sort"></span></th>
                        <th [jhiSortBy]="ColumnHeaders.GID"><span jhiTranslate="design-crosses.source.list.gid">GID</span> <span class="fa fa-sort"></span></th>
                        <th [jhiSortBy]="ColumnHeaders.GROUP_ID"><span jhiTranslate="design-crosses.source.list.group.id">GROUP ID</span> <span class="fa fa-sort"></span></th>
                    </tr>
                    </thead>
                    <tbody *ngIf="crossSourceEntries.length" cdkDropList [cdkDropListConnectedTo]="['femaleParentsListDrop', 'maleParentsListDrop']">
                        @for (entry of crossSourceEntries; track entry.entryId;) {
                            <tr (click)="toggleSelect($event, $index, entry); $event.stopPropagation()"
                                [class.selected]="isSelected(entry)"
                                (mousedown)="$event.preventDefault()"
                                cdkDrag (cdkDragEntered)="dragStart($event, entry)"
                                #p="ngbPopover"
                                (contextmenu)="showRightClickMenu($event, p)"
                                [autoClose]="true"
                                [triggers]="'manual'"
                                [ngbPopover]="cellContextMenu">
                                <div *cdkDragPlaceholder>&nbsp;</div>
                                <td><input type="checkbox" class="form-check-input" [checked]="isSelected(entry)" (click)="toggleSelect($event, $index, entry, true); $event.stopPropagation()"></td>
                                <td>{{entry.entryNumber}}</td>
                                <td><a class="link" (click)="germplasmDetailsPopupService.open(entry.gid)"><truncate-span [textInput]="entry.designation" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span></a></td>
                                <td><truncate-span [textInput]="entry.cross" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span></td>
                                <td><a class="link" (click)="germplasmDetailsPopupService.open(entry.gid)">{{entry.gid}}</a></td>
                                <td>{{ entry.groupGid ? entry.groupGid : '-' }}</td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>


<ng-template #cellContextMenu>
    <div class="p-2">
        <button class="btn btn-sm btn-outline-info w-100" type="button" (click)="addToParentsList(true)" jhiTranslate="design-crosses.actions.add.to.female">
        </button>
        <button class="btn btn-sm mt-2 btn-outline-info w-100" type="button" (click)="addToParentsList(false)" jhiTranslate="design-crosses.actions.add.to.male">
        </button>
    </div>
</ng-template>
